// src/components/HistoryItem.jsx
import React, { useState } from 'react';
import { User, Edit3, Calendar, CheckCircle2, XCircle, Mail, LoaderCircle, ImageOff } from 'lucide-react';

export default function HistoryItem({ item, isAdmin, onImageClick }) {
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  return (
    <div className="relative bg-gray-100 rounded-lg shadow-sm p-4 flex items-center space-x-4">
      {/* Ícone de status (Válido/Inválido) */}
      <div className="absolute top-2 right-2 z-10"> {/* Adicionado z-10 para garantir que fique acima da imagem */}
        {item.validacao.toLowerCase() === 'foto boa' ? (
          <CheckCircle2 size={24} className="text-green-500 bg-white rounded-full" />
        ) : (
          <XCircle size={24} className="text-red-500 bg-white rounded-full" />
        )}
      </div>

      {/* Container da Imagem com Lógica de Loading */}
      <div className="relative w-20 h-20 rounded-md bg-gray-300 flex-shrink-0 flex items-center justify-center overflow-hidden">
        {imageLoading && (
          <div className="absolute inset-0 flex items-center justify-center">
            <LoaderCircle size={24} className="text-gray-500 animate-spin" />
          </div>
        )}

        {imageError && !imageLoading && (
          <div className="absolute inset-0 flex items-center justify-center">
            <ImageOff size={24} className="text-red-400" />
          </div>
        )}
        
        <img 
          src={item.thumbnail_url || item.image_url} 
          alt="Preview do envio" 
          className={`w-full h-full object-cover cursor-pointer transition-opacity duration-300 ${imageLoading || imageError ? 'opacity-0' : 'opacity-100'}`}
          onLoad={() => setImageLoading(false)}
          onError={() => {
            setImageLoading(false);
            setImageError(true);
          }}
          onClick={onImageClick}
        />
      </div>


      {/* Informações do item */}
      <div className="text-sm">
        <p className="flex items-center"><User size={14} className="mr-2" /> <strong>Driver ID</strong>{": "}{item.driver_id}</p>
        <p className="flex items-center"><Calendar size={14} className="mr-2" /> <strong>Data</strong>{": "}{item.date}</p>
        {isAdmin && (
          <p className="flex items-center"><Mail size={14} className="mr-2" /> <strong>Usuário:</strong>{item.email_user}</p>
        )}
      </div>
    </div>
  );
}